const GENERAL_TABLE = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$40 per day (2 days minimum)" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$40",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      "Chassis Split": "$120",
      note:
        "Applies if the chassis and/or container is returned to a different rail ramp or port from the one originally  picked up from."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed ($170). Apply when weight is over 38000 lbs.  in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note:
        "Applies when cargo weight is over 44.000 lbs for all container sizes."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1)(1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$160",
      note:
        "Applies when lanes exceed 150 miles and early appointments for loading/unloading."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip – Cancellation fee may apply"
    },
    {
      Storage: "$45",
      note: "This charge is per day."
    }
  ],
  footer_upper_text: "",
  footer_note: ""
};

const NY_NJ_DRAYAGE_TABLE = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$55 per day (2 days minimum)" },
    { "Congestion Fee": "$200" },
    { Prepull: "$160" },
    { Storage: "$80 per day (if needed)" },
    { GCT: "$230" },
    { NYCT: "$250" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$55",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      "Chassis Split": "$120",
      note:
        "Applies if the chassis and/or container is returned to a different rail ramp or port from the one originally  picked up from."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed ($170). Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note:
        "Applies when cargo weight is over 44.000 lbs for all container sizes."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1) (1.2) (1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$160",
      note:
        "Applies when lanes exceed 150 miles and early appointments for loading/unloading."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip – Cancellation fee may apply."
    },
    {
      Storage: "$80",
      note: "This charge is per day."
    }
  ],
  footer_upper_text: "",
  footer_note:
    "Note: Tolls will apply out of GCT // NYCT. Rate does not apply out of RED HOOK TERMINAL"
};

const CALIFORNIA_DRAYAGE_TABLE = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$60 per day (2 days minimum) If WCCP is $90 per day" },
    { Prepull: "$160" },
    { "Chassis Split": "$95" },
    { "Congestion (if applicable)": "$220" },
    { Storage: "$60 per day until the container is returned." },
    { "Cancellation fee": "May apply" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    },
    { "Night gate & weekend fee ": "May apply" }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$60",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      "Chassis Split": "$95",
      note:
        "Applies if the chassis and/or container is returned to a different rail ramp or port from the one originally  picked up from."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$120",
      note:
        "Charges are per day and two (2) days minimum will be billed ($240). Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note:
        "Applies when cargo weight is over 44.000 lbs for all container sizes."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1) (1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$160",
      note:
        "Applies when lanes exceed 150 miles and early appointments for loading/unloading."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip – Cancellation may apply"
    },
    {
      Storage: "$60",
      note: "This charge is per day."
    }
  ],
  footer_upper_text: "",
  footer_note:
    "Note: CLEAN TRUCK FEE and PIER PASS must be claimed by the customer. Peak Season fee may apply. Dry-run to the port (applies for equipment unavailability, Pier Pass has not been cleared, Demurrage is not cleared, port rejections, etc.)"
};

const BALTIMORE_DRAYAGE_TABLE = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$45 per day (2 days minimum)" },
    { "Chassis Split": "$90 out of Seagirt Terminal" },
    { Prepull: "$160" },
    { "Tolls may apply": "$" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$45",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      "Chassis Split": "$90",
      note:
        "Applies if the chassis and/or container is returned to a different rail ramp or port from the one originally picked up from."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed ($170). Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note:
        "Applies when cargo weight is over 44.000 lbs for all container sizes."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1) (1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$160",
      note:
        "Applies when lanes exceed 150 miles and early appointments for loading/unloading."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip - Cancellation fee may apply."
    },
    {
      Storage: "$60",
      note: "This charge is per day."
    }
  ],
  footer_upper_text: "",
  footer_note: ""
};

const BOSTON_DRAYAGE_TABLE = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$40 per day (2 days minimum)" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        "$"
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$40",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees  must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      "Chassis Split": "$120",
      note:
        "Applies if the chassis and/or container is returned to a different rail ramp or port from the one originally  picked up from."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed ($170). Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note:
        "Applies when cargo weight is over 44.000 lbs for all container sizes."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1)(1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$160",
      note:
        "Applies when lanes exceed 150 miles and early appointments for loading/unloading."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip – Cancellation fee may apply."
    },
    {
      Storage: "$45",
      note: "This charge is per day."
    }
  ],
  footer_upper_text: "",
  footer_note:
    "Note: Terminal usage fee may apply for 40’STD/HC $73.50 & 20’STD $36.75 + admin fee."
};

const OAKLAND_DRAYAGE_TABLE = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$55 per day (2 days minimum)" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$55",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      "Chassis Split": "$120",
      note:
        "Applies if the chassis and/or container is returned to a different rail ramp or port from the one originally  picked up from."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed ($170). Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note:
        "Applies when cargo weight is over 44.000 lbs for all container sizes."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1)(1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$160",
      note:
        "Applies when lanes exceed 150 miles and early appointments for loading/unloading."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip – Cancellation fee may apply"
    },
    {
      Storage: "$100",
      note: "This charge is per night. After 3 days $130 per day"
    }
  ],
  footer_upper_text: "",
  footer_note: "Note: Gate fee may apply"
};

const CHICAGO_DRAYAGE_TABLE = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$40 per day (2 days minimum)" },
    { "Chassis Split": "$150" },
    { Prepull: "$220" },
    { Congestion: "$150" },
    { Storage: "$60 per day (If applicable)" },
    { Tolls: "$100 (If applicable)" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$40",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      "Chassis Split": "$150",
      note:
        "Applies if the chassis pick-up/delivery location is different to the container pick-up/delivery."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed ($170). Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note:
        "Applies when cargo weight is over 44.000 lbs for all container sizes. "
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1)(1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$220",
      note:
        "Applies when lanes exceed 150 miles and early appointments for loading/unloading."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip – Cancellation fee may apply."
    },
    {
      Storage: "$60",
      note: "This charge is per day."
    }
  ],
  footer_upper_text: "",
  footer_note: ""
  /* "Note: there is a chassis shortage and we will not be responsible for Demurrage/Rail Storage." */
};

const KANSAS_DRAYAGE_TABLE = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$40 per day (2 days minimum)" },
    { "Chassis Split": "$130 each (Two  may apply)" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$40",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      "Chassis Split": "$130",
      note:
        "Applies if the chassis and/or container is returned to a different rail ramp or port from the one originally  picked up from."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed ($170). Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note:
        "Applies when cargo weight is over 44.000 lbs for all container sizes."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1)(1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$160",
      note:
        "Applies when lanes exceed 150 miles and early appointments for loading/unloading."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip – Cancellation fee may apply"
    },
    {
      Storage: "$55",
      note: "This charge is per day."
    }
  ],
  footer_upper_text: "",
  footer_note:
    "Note: There will be a $180 surcharge added to the base rate for all loads/chassis originating or terminating back to Edgerton, KS or LPKC BNSF."
};

const CINCINNATI_COLUMBUS_DRAYAGE_TABLE = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$40 per day (2 days minimum)" },
    { "Chassis Split": "$90 each (two charges may apply: pick up and return)" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$40",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      "Chassis Split": "$90 each",
      note:
        "Applies if the chassis and/or container is returned to a different rail ramp or port from the one originally  picked up from."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed ($170). Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note:
        "Applies when cargo weight is over 44.000 lbs for all container sizes."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1)(1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$160",
      note:
        "Applies when lanes exceed 150 miles and early appointments for loading/unloading."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip – Cancellation fee may apply"
    },
    {
      Storage: "$45",
      note: "This charge is per day."
    }
  ],
  footer_upper_text: "",
  footer_note: ""
};

const MIAMI_DRAYAGE_TABLE = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$40 per day (2 days minimum)" },
    { Storage: "$65 per day (if applies)" },
    { Prepull: "$180 (if applies)" },
    { "Congestion fee may apply": "" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$40",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      "Chassis Split": "$120",
      note:
        "Applies if the chassis and/or container is returned to a different rail ramp or port from the one originally  picked up from."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$130",
      note:
        "Charges are per day and two (2) days minimum will be billed. Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note:
        "Applies when cargo weight is over 44.000 lbs for all container sizes."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1)(1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$180",
      note:
        "Applies when lanes exceed 150 miles and early appointments for loading/unloading."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip – Cancellation fee may apply."
    },
    {
      Storage: "$65",
      note: "This charge is per day."
    }
  ],
  footer_upper_text: "",
  footer_note:
    "Note: Due to terminal congestion NO FREE TIME in/out of Miami/Port Everglades terminals."
};

const PORT_EVERGLADES_DRAYAGE_TABLE = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$40 per day (2 days minimum)" },
    { Storage: "$65 per day (if applies)" },
    { Prepull: "$230 (if applies)" },
    { "Congestion may apply": "" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$40",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      "Chassis Split": "$120",
      note:
        "Applies if the chassis and/or container is returned to a different rail ramp or port from the one originally  picked up from."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$130",
      note:
        "Charges are per day and two (2) days minimum will be billed. Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note:
        "Applies when cargo weight is over 44.000 lbs for all container sizes."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1)(1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$230",
      note:
        "Applies when lanes exceed 150 miles and early appointments for loading/unloading."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip – Cancellation fee may apply."
    },
    {
      Storage: "$65",
      note: "This charge is per day."
    }
  ],
  footer_upper_text: "",
  footer_note:
    "Note: Due to terminal congestion NO FREE TIME in/out of Miami/Port Everglades terminals."
  /* "Export containers returning to Port Everglades might have an extra charge of $28.50 for a scale fee." */
};

const MEMPHIS_DRAYAGE_TABLE = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$40 per day (2 days minimum)" },
    { "Chassis split": "$160 each (Two may apply)" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$40",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping paperwork for the carrier to review."
    },
    {
      "Chassis Split": "$160 each",
      note:
        "Applies if the chassis and/or container is returned to a different rail ramp or port from the one originally  picked up from."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container needs to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed ($170). Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note:
        "Applies when cargo weight is over 44.000 lbs for all container sizes."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1) (1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$160",
      note:
        "Applies when lanes exceed 150 miles and early appointments for loading/unloading."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip – Cancellation fee may apply."
    },
    {
      Storage: "$45",
      note: "This charge is per day."
    }
  ],
  footer_upper_text: "",
  footer_note: "Note: If comming/going to UP/CP add $120 or NS add $170"
};

const MINNEAPOLIS_DRAYAGE_TABLE = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$45 per day (2 days minimum)" },
    {
      "Chassis split": "$100 each (two charges may apply: pick up and return)"
    },
    { "CP Surcharge (If used as origin or termination)": "$120" },
    { "Chassis flip": "$120" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$45",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      "Chassis Split": "$100",
      note:
        "Applies if the chassis and/or container is returned to a different rail ramp or port from the one originally  picked up from."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$95",
      note:
        "Charges are per day and two (2) days minimum will be billed ($170). Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note:
        "Applies when cargo weight is over 44.000 lbs for all container sizes."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1) (1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$160",
      note:
        "Applies when lanes exceed 150 miles and early appointments for loading/unloading."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip – Cancellation fee may apply."
    },
    {
      Storage: "$45",
      note: "This charge is per day."
    }
  ],
  footer_upper_text: "",
  footer_note: "Rate not applicable in New Richmond Terminal in MN"
};

const ATLANTA_DRAYAGE_TABLE = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$40 per day (2 days minimum)" },
    { "Chassis split": "$120" },
    { "Intermodal fee": "$180" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        "$"
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$40",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      "Chassis Split": "$120",
      note:
        "Applies if the chassis and/or container is returned to a different rail ramp or port from the one originally  picked up from."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed ($170). Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note:
        "Applies when cargo weight is over 44.000 lbs for all container sizes."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1) (1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$160",
      note:
        "Applies when lanes exceed 150 miles and early appointments for loading/unloading."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip – Cancellation fee may apply."
    },
    {
      Storage: "$50",
      note: "This charge is per day."
    }
  ],
  footer_upper_text: "",
  footer_note: ""
};
const HOUSTON = {
  rate_table: [
    { "Linehaul Rate + FSC (%)": "$" },
    { Chassis: "$45 per day (2 days minimum)" },
    { Prepull: "$180 (If needed)" },
    { "Congestions applies": "$220" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    },
    { "Layover may apply": "" }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$45",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      "Chassis Split": "$120 each",
      note:
        "Applies if the chassis and/or container is returned to a different rail ramp or port from the one originally  picked up from."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed. Over 38000 lbs. in a 20' / Over 44000 lbs. in a  40'."
    },
    {
      "Overweight Fee": "-",
      note:
        "Applies when cargo weight is over 44.000 lbs for all container sizes. "
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: (1.1) (1.2) (1.3) (1.5) (2.3) (3.1) (4.1) (4.2) (4.3) (5.1) (6.1) (6.2) (7) (9.1)"
    },
    {
      "Pre-pull": "$180",
      note:
        "Applies when lanes exceed 150 miles and early appointments for loading/unloading."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip – Cancellation fee may apply."
    },
    {
      Storage: "$45",
      note: "This charge is per day."
    }
  ],
  footer_upper_text: "",
  footer_note:
    "Note: IF SHIPMENT IS OUT/IN OF JACINTO PORT, TWO CHASSIS SPLITS WILL APPLY. RATE DOES NOT APPLY OUT OF CITY DOCKS."
};
const NEW_ORLEANS = {
  rate_table: [
    { "Linehaul Rate + FSC (%)": "$" },
    { Chassis: "$40 per day (2 days minimum)" },
    { "Chassis split": "$120" },
    { Congestion: "$150" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$40",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      "Chassis Split": "$120",
      note:
        "Applies if the chassis and/or container is returned to a different rail ramp or port from the one originally picked up from."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed. Over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note:
        "Apply when cargo weight is over 44.000 lbs for all container sizes."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: (1.1) (1.2) (1.3) (1.5) (2.3) (3.1) (4.1) (4.2) (4.3) (5.1) (6.1) (6.2) (7) (9.1)"
    },
    {
      "Pre-pull": "$160",
      note:
        "Applies when lanes exceed 150 miles and early appointments for loading/unloading."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip – Cancellation fee may apply."
    },
    {
      Storage: "$45",
      note: "This charge is per day."
    }
  ],
  footer_upper_text: "",
  footer_note: ""
};
const NORFOLK = {
  rate_table: [
    { "Linehaul Rate + FSC (%)": "$" },
    { Chassis: "$40 per day (2 days minimum)" },
    { "Congestion fee May Apply": "May apply" },
    { Toll: "$60" },
    { Prepull: "$160" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$40",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      "Chassis Split": "$120",
      note:
        "Applies if the chassis and/or container is returned to a different rail ramp or port from the one originally  picked up from."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed. Over 38000 lbs. in a 20' / Over 44000 lbs. in a  40'"
    },
    {
      "Overweight Fee": "-",
      note:
        "Applies when cargo weight is over 44.000 lbs for all container sizes."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: (1.1) (1.2) (1.3) (1.5) (2.3) (3.1) (4.1) (4.2) (4.3) (5.1) (6.1) (6.2) (7) (9.1)"
    },
    {
      "Pre-pull": "$160",
      note:
        "Applies when lanes exceed 150 miles and early appointments for loading/unloading."
    },
    {
      Layover: "$400",
      note:
        "Applies after 6 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip - Cancellation fee may apply."
    },
    {
      Storage: "$65",
      note: "This charge is per day."
    }
  ],
  footer_upper_text: "",
  footer_note: ""
};
const DETROIT_DRAYAGE_TABLE = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$50 per day (2 days minimum)" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    },
    { "Congestion Fee NS": "$160" },
    { "Chassis Split": "$120" }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$60",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to  review."
    },
    {
      "Chassis Split": "$120",
      note:
        "Applies if the chassis pick-up/delivery location is different to the container pick-up/delivery."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility  used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed ($170). Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note: "Fee depends on the state the cargo is being hauled at."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1)(1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$160",
      note: "Recommended for early appointments and/or emergencies."
    },
    {
      "Scale Tickets": "$100",
      note:
        "The cost of $100 to scale light (empty) and $100 to scale heavy (loaded)."
    },
    {
      "Stop-off": "$200",
      note: "Extra stop on loading /unloading process."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      Residential: "-",
      note: ""
    },
    {
      "Placard Removal Sweep Out": "$120/$80",
      note: "The consignee is responsible for this process."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip"
    },
    {
      Storage: "$65",
      note: "This charge is per day"
    }
  ],
  footer_upper_text: "",
  footer_note: ""
};
const CHARLESTON_DRAYAGE_TABLE = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$45 per day (2 days minimum)" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is  loaded/unloaded":
        ""
    },
    { "Congestion Fee": "$180" }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$45",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      "Chassis Split": "$120",
      note:
        "Applies if the chassis pick-up/delivery location is different to the container pick-up/delivery."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility  used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed ($170). Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note: "Fee depends on the state the cargo is being hauled at."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1)(1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$160",
      note: "Recommended for early appointments and/or emergencies."
    },
    {
      "Scale Tickets": "$100",
      note: "Recommended for early appointments and/or emergencies."
    },
    {
      "Stop-off": "$200",
      note: "Extra stop on loading /unloading process."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      Residential: "-",
      note: ""
    },
    {
      "Placard Removal Sweep Out": "$120/$80",
      note: "The consignee is responsible for this process."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip"
    },
    {
      Storage: "$75",
      note: "This charge is per day"
    }
  ],
  footer_upper_text: "",
  footer_note: ""
};

//TEMP CONTROL: drayageCannedResponsesTables.

const DRAYAGE_QUOTE_GENERAL = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$38 per day (2 days minimum)" },
    { Reefer: "$200" },
    {
      "Pre Pull":
        "$160 may be needed due to low capacity to deliver (storage and plug in charges may also apply)"
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$38",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      "Chassis Split": "$120",
      note:
        "Applies if the chassis pick-up/delivery location is different to the container pick-up/delivery."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$100",
      note: "Charges are per day and two (2) days minimum will be billed."
    },
    {
      "Overweight Fee": "-",
      note:
        "Fee depends on the state the cargo is being hauled at. Max weight with permit for 40ft reefer containers is 48,000 lbs (this may change depending on the state, could be less at some locations)"
    },
    {
      Hazmat: "$165",
      note:
        "We cannot haul: Class (1.1)(1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Congestion Fee": "-",
      note: "Charges apply depending on the carrier or ports facility."
    },
    {
      "Toll Charge": "$220",
      note: "If it applies."
    },
    {
      "Terminal/Pier Pass": "-",
      note: "Depends on port's fee + administrative fee."
    },
    {
      "Pre-pull": "$160",
      note: "Recommended for early appointments and/or emergencies."
    },
    {
      "Scale Tickets": "$100",
      note:
        "The cost of $100 to scale light (empty) and $100 to scale heavy (loaded)."
    },
    {
      "Stop-off": "$200",
      note: "Extra stop on loading /unloading process."
    },
    {
      "Driver Detention": "$100",
      note: "1 Hour is free for loading/unloading."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      Residential: "$165",
      note: ""
    },
    {
      Reefer: "$200",
      note: ""
    },
    {
      "Placard Removal Sweep Out": "$120",
      note: "The consignee is responsible for this process."
    },
    {
      "Truck Order Not Used": "-",
      note:
        "This charge includes linehaul cost + FSC + two (2) days of chassis."
    },
    {
      "Reefer Storage": "$125-$180",
      note: "This charge is per day."
    },
    {
      "Storage Empty Reefer or NOP Reefer": "$80 per day",
      note: "This charge is per day."
    }
  ],
  footer_upper_text:
    "(No free drops unless advised otherwise, if needed please add one more roundtrip)",
  footer_note:
    "Due to current port congestion and equipment shortage, GLT will not be responsible for any demurrage or per diem charge generated during the operation**"
};

/* TEMP CONTROL CANNED */

const DRAYAGE_CALIFORNIA_LA_LB = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$75 per day (2 days minimum) If WCCP is $90 per day" },
    { Reefer: "$200" },
    {
      Prepull: "$160"
    },
    { "Chassis Split": "$95" },
    {
      "Congestion (if applicable)": "$220"
    },
    { "Cancellation fee": "May apply" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    },
    {
      "Night gate & weekend fee ": "May apply"
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$75",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      Reefer: "$200",
      note: ""
    },
    {
      "Chassis Split": "$95",
      note:
        "Applies if the chassis pick-up/delivery location is different to the container pick-up/delivery."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$120",
      note:
        "Charges are per day and two (2) days minimum will be billed ($240). Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note: "Fee depends on the state the cargo is being hauled at."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1) (1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$160",
      note: "Recommended for early appointments and/or emergencies."
    },
    {
      "Scale Tickets": "$100",
      note:
        "The cost of $100 to scale light (empty) and $100 to scale heavy (loaded)."
    },
    {
      "Stop-off": "$200",
      note: "Extra stop on loading /unloading process."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      Residential: "-",
      note: ""
    },
    {
      "Placard Removal Sweep Out": "$120/$80",
      note: "The consignee is responsible for this process."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip"
    },
    {
      "Cancellation fee": "-",
      note: "May Apply"
    },
    {
      "CLEAN TRUCK FEE and PIER PASS": "-",
      note: "Must be claimed by the customer"
    },
    {
      "Reefer Storage": "$125 to $180",
      note: "This charge is per day."
    },
    {
      "Empty Storage": "$90",
      note: "This charge is per day."
    }
  ],
  footer_upper_text: "",
  footer_note:
    "Note: CLEAN TRUCK FEE and PIER PASS must be claimed by the customer. Peak Season fee may apply. Dry-run to the port (applies for equipment unavailability, Pier Pass has not been cleared, Demurrage is not cleared, port rejections, etc.)"
};

const DRAYAGE_QUOTE_NY_NJ = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$ " },
    { Chassis: "$50 per day (2 days minimum)" },
    { Reefer: "$200" },
    { "Congestion Fee": "$220" },
    { Prepull: "$200" },
    { Storage: "$80 per day (if needed)" },
    { "APM Terminals": "$230" },
    { GCT: "$230" },
    { NYCT: "$250" },
    { MAHER: "$175" },
    { PNCT: "$220" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$50",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      Reefer: "$200",
      note: ""
    },
    {
      "Chassis Split": "$120",
      note:
        "Applies if the chassis pick-up/delivery location is different to the container pick-up/delivery."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed ($170). Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note: "Fee depends on the state the cargo is being hauled at."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1) (1.2) (1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$200",
      note: "Recommended for early appointments and/or emergencies."
    },
    {
      "Scale Tickets": "$100",
      note:
        "The cost of $100 to scale light (empty) and $100 to scale heavy (loaded)."
    },
    {
      "Stop-off": "$200",
      note: "Extra stop on loading /unloading process."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      Residential: "-",
      note: ""
    },
    {
      "Placard Removal Sweep Out": "$120/$80",
      note: "The consignee is responsible for this process."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip"
    },
    {
      "Reefer Storage": "$125 to $180",
      note: "This charge is per day."
    },
    {
      "Empty Storage": "$90",
      note: ""
    }
  ],
  footer_upper_text: "",
  footer_note:
    "Note: Tolls will apply out of GCT // NYCT. Rate does not apply out of RED HOOK TERMINAL"
};

const DRAYAGE_QUOTE_MIAMI = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$ " },
    { Chassis: "$40 per day (2 days minimum)" },
    { Reefer: "$200" },
    { Storage: "$65 per day (if applies)" },
    { Prepull: "$180 (if applies)" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$40",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      Reefer: "$200",
      note: ""
    },
    {
      "Chassis Split": "$120",
      note:
        "Applies if the chassis pick-up/delivery location is different to the container pick-up/delivery."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$130",
      note:
        "Charges are per day and two (2) days minimum will be billed. Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note: "Fee depends on the state the cargo is being hauled at."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1)(1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$180",
      note: "Recommended for early appointments and/or emergencies."
    },
    {
      "Scale Tickets": "$100",
      note:
        "The cost of $100 to scale light (empty) and $100 to scale heavy (loaded)."
    },
    {
      "Stop-off": "$200",
      note: "Extra stop on loading /unloading process."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      Residential: "-",
      note: ""
    },
    {
      "Placard Removal Sweep Out": "$120/$80",
      note: "The consignee is responsible for this process."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip"
    },
    {
      "Reefer Storage": "$125 to $180",
      note: "This charge is per day."
    },
    {
      "Empty Storage": "$90",
      note: "This charge is per day."
    }
  ],
  footer_upper_text: "",
  footer_note:
    "Note: Due to terminal congestion NO FREE TIME in/out of Miami/Port Everglades terminals."
};

const DRAYAGE_QUOTE_CHICAGO = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$ " },
    { Chassis: "$40 per day (2 days minimum)" },
    { Reefer: "$200" },
    { "Chassis Split": "$180" },
    { Prepull: "$210" },
    { Congestion: "$230" },
    { Storage: "$60 per day (If applicable)" },
    { Tolls: "$100 (If applicable)" },
    { "If out of Elwood/Joliet please add:": "$100 - $180" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$40",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      Reefer: "$200",
      note: ""
    },
    {
      "Chassis Split": "$180",
      note:
        "Applies if the chassis pick-up/delivery location is different to the container pick-up/delivery."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed ($170). Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note: "Fee depends on the state the cargo is being hauled at."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1)(1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$210",
      note: "Recommended for early appointments and/or emergencies."
    },
    {
      "Scale Tickets": "$100",
      note:
        "The cost of $100 to scale light (empty) and $100 to scale heavy (loaded)."
    },
    {
      "Stop-off": "$200",
      note: "Extra stop on loading /unloading process."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      Residential: "-",
      note: ""
    },
    {
      "Placard Removal Sweep Out": "$120/$80",
      note: "The consignee is responsible for this process."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip"
    },
    {
      "Reefer Storage": "$125 to $180",
      note: "This charge is per day."
    },
    {
      "Empty Storage": "$90",
      note: ""
    }
  ],
  footer_upper_text: "",
  footer_note:
    "Note: there is a chassis shortage and we will not be responsible for Demurrage/Rail Storage."
};
const HOUSTON_TEMP_CONTROL = {
  rate_table: [
    { "Linehaul Rate + FSC (%)": "$" },
    { Chassis: "$45 per day (2 days minimum)" },
    { Reefer: "$200" },
    { Prepull: "$180 (If needed) " },
    { "Congestion applies": "$220" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    },
    { "Layover may apply": "" }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$45",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      Reefer: "$200",
      note: ""
    },
    {
      "Chassis Split": "$120",
      note:
        "Applies if the chassis pick-up/delivery location is different to the container pick-up/delivery."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed. Over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note: "Fee depends on the state the cargo is being hauled at."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: (1.1) (1.2) (1.3) (1.5) (2.3) (3.1) (4.1) (4.2) (4.3) (5.1) (6.1) (6.2) (7) (9.1)"
    },
    {
      "Congestion Fee": "$220",
      note: "Charges apply depending on the carrier or ports facility."
    },
    {
      "Toll Charge": "$220",
      note: "If it applies."
    },
    {
      "Pre-pull": "$180-220",
      note: "Recommended for early appointments and/or emergencies."
    },
    {
      "Scale Tickets": "$100",
      note:
        "The cost of $100 to scale light (empty) and $100 to scale heavy (loaded)."
    },
    {
      "Stop-off": "$200",
      note: "Extra stop on loading /unloading process."
    },
    {
      "Driver Detention": "$100",
      note: "1 Hour is free for loading/unloading."
    },
    {
      Layover: "$400",
      note:
        "Applies after 6 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      "Placard Removal Sweep Out": "$120/$80",
      note: "The consignee is responsible for this process."
    },
    {
      "Truck Order Not Used": "-",
      note:
        "This charge includes linehaul cost + FSC + two (2) days of chassis."
    },
    {
      "Reefer Storage": "$125 - $180",
      note: "This charge is per day."
    },
    {
      "Empty Storage": "$90",
      note: "This charge is per day."
    }
  ],
  footer_upper_text: "",
  footer_note: "Note: RATE DOES NOT APPLY OUT OF CITY DOCKS"
};
const NEW_ORLEANS_TEMP_CONTROL = {
  rate_table: [
    { "Linehaul Rate + FSC (%)": "$" },
    { Chassis: "$40 per day (2 days minimum)" },
    { "Chassis split": "$120" },
    { Reefer: "$200" },
    { Congestion: "$150" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$40",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      "Reefer Fee": "$200",
      note: ""
    },
    {
      "Chassis Split": "$120",
      note:
        "Applies if the chassis pick-up/delivery location is different to the container pick-up/delivery."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed. Over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note: "Fee depends on the state the cargo is being hauled at."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: (1.1) (1.2) (1.3) (1.5) (2.3) (3.1) (4.1) (4.2) (4.3) (5.1) (6.1) (6.2) (7) (9.1)"
    },
    {
      "Congestion Fee": "-",
      note: "Charges apply depending on the carrier or ports facility."
    },
    {
      "Toll Charge": "$220",
      note: "If it applies."
    },
    {
      "Terminal/Pier Pass": "-",
      note: "Depends on port's fee + administrative fee."
    },
    {
      "Pre-pull": "$160",
      note: "Recommended for early appointments and/or emergencies."
    },
    {
      "Scale Tickets": "$100",
      note:
        "The cost of $100 to scale light (empty) and $100 to scale heavy (loaded)."
    },
    {
      "Stop-off": "$200",
      note: "Extra stop on loading /unloading process."
    },
    {
      "Driver Detention": "$100",
      note: "1 Hour is free for loading/unloading."
    },
    {
      Layover: "$400",
      note:
        "Applies after 6 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      Residential: "-",
      note: ""
    },
    {
      "Placard Removal Sweep Out": "$120/$80",
      note: "The consignee is responsible for this process."
    },
    {
      "Truck Order Not Used": "-",
      note:
        "This charge includes linehaul cost + FSC + two (2) days of chassis."
    },
    {
      "Reefer Storage": "$125 - $180",
      note: "This charge is per day."
    },
    {
      "Empty Storage": "$90",
      note: "This charge is per day."
    }
  ],
  footer_upper_text: "",
  footer_note: ""
};
const NORFOLK_TEMP_CONTROL = {
  rate_table: [
    { "Linehaul Rate + FSC (%)": "$" },
    { Chassis: "$45 per day (2 days minimum)" },
    { Reefer: "$200" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    },
    { "Congestion fee May Apply": "May apply" },
    { Toll: "$60" },
    { Prepull: "$160" }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$45",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      Reefer: "$200",
      note: ""
    },
    {
      "Chassis Split": "$120",
      note:
        "Applies if the chassis pick-up/delivery location is different to the container pick-up/delivery."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed. Over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note: "Fee depends on the state the cargo is being hauled at."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: (1.1) (1.2) (1.3) (1.5) (2.3) (3.1) (4.1) (4.2) (4.3) (5.1) (6.1) (6.2) (7) (9.1)"
    },
    {
      "Congestion Fee": "-",
      note: "Charges apply depending on the carrier or ports facility."
    },
    {
      "Toll Charge": "$60",
      note: "If it applies."
    },
    {
      "Terminal/Pier Pass": "",
      note: "Depends on port's fee + administrative fee."
    },
    {
      "Pre-pull": "$160",
      note: "Recommended for early appointments and/or emergencies."
    },
    {
      "Scale Tickets": "$100",
      note:
        "The cost of $100 to scale light (empty) and $100 to scale heavy (loaded)."
    },
    {
      "Stop-off": "$200",
      note: "Extra stop on loading /unloading process."
    },
    {
      "Driver Detention": "$100",
      note: "1 Hour is free for loading/unloading."
    },
    {
      Layover: "$400",
      note:
        "Applies after 6 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      Residential: "-",
      note: ""
    },
    {
      "Placard Removal Sweep Out": "$120/$80",
      note: "The consignee is responsible for this process."
    },
    {
      "Truck Order Not Used": "-",
      note:
        "This charge includes linehaul cost + FSC + two (2) days of chassis."
    },
    {
      "Reefer Storage": "$125 to $180",
      note: "This charge is per day."
    },
    {
      "Empty Storage": "$90",
      note: ""
    }
  ],
  footer_upper_text: "",
  footer_note: ""
};

const BOSTON_TEMP_CONTROL = {
  rate_table: [
    { "Linehaul Rate + FSC (%)": "$" },
    { Chassis: "$45 per day (2 days minimum)" },
    { Reefer: "$200" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    },
    { "Terminal Fee": "May apply" },
    { Prepull: "$160" }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$45",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      Reefer: "$200",
      note: ""
    },
    {
      "Chassis Split": "$120",
      note:
        "Applies if the chassis pick-up/delivery location is different to the container pick-up/delivery."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed. Over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note: "Fee depends on the state the cargo is being hauled at."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: (1.1) (1.2) (1.3) (1.5) (2.3) (3.1) (4.1) (4.2) (4.3) (5.1) (6.1) (6.2) (7) (9.1)"
    },
    {
      "Congestion Fee": "-",
      note: "Charges apply depending on the carrier or ports facility."
    },
    {
      "Toll Charge": "$60",
      note: "If it applies."
    },
    {
      "Terminal/Pier Pass": "",
      note: "Depends on port's fee + administrative fee."
    },
    {
      "Pre-pull": "$160",
      note: "Recommended for early appointments and/or emergencies."
    },
    {
      "Scale Tickets": "$100",
      note:
        "The cost of $100 to scale light (empty) and $100 to scale heavy (loaded)."
    },
    {
      "Stop-off": "$200",
      note: "Extra stop on loading /unloading process."
    },
    {
      "Driver Detention": "$100",
      note: "1 Hour is free for loading/unloading."
    },
    {
      Layover: "$400",
      note:
        "Applies after 6 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      Residential: "-",
      note: ""
    },
    {
      "Placard Removal Sweep Out": "$120/$80",
      note: "The consignee is responsible for this process."
    },
    {
      "Truck Order Not Used": "-",
      note:
        "This charge includes linehaul cost + FSC + two (2) days of chassis."
    },
    {
      "Reefer Storage": "$125 to $180",
      note: "This charge is per day."
    },
    {
      "Empty Storage": "$90",
      note: ""
    }
  ],
  footer_upper_text: "",
  footer_note: ""
};

const CINCINNATI_COLOMBUS_TEMP_CONTROL = {
  rate_table: [
    { "Linehaul Rate + FSC (%)": "$" },
    { Chassis: "$45 per day (2 days minimum)" },
    { Reefer: "$200" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    },
    { "Chassis Split": "$120 per occurrence (2 may apply)" },
    { Prepull: "$160" }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$45",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      Reefer: "$200",
      note: ""
    },
    {
      "Chassis Split": "$120",
      note:
        "Applies if the chassis pick-up/delivery location is different to the container pick-up/delivery."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed. Over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note: "Fee depends on the state the cargo is being hauled at."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: (1.1) (1.2) (1.3) (1.5) (2.3) (3.1) (4.1) (4.2) (4.3) (5.1) (6.1) (6.2) (7) (9.1)"
    },
    {
      "Congestion Fee": "-",
      note: "Charges apply depending on the carrier or ports facility."
    },
    {
      "Toll Charge": "$60",
      note: "If it applies."
    },
    {
      "Terminal/Pier Pass": "-",
      note: "Depends on port's fee + administrative fee."
    },
    {
      "Pre-pull": "$160",
      note: "Recommended for early appointments and/or emergencies."
    },
    {
      "Scale Tickets": "$100",
      note:
        "The cost of $100 to scale light (empty) and $100 to scale heavy (loaded)."
    },
    {
      "Stop-off": "$200",
      note: "Extra stop on loading /unloading process."
    },
    {
      "Driver Detention": "$100",
      note: "1 Hour is free for loading/unloading."
    },
    {
      Layover: "$400",
      note:
        "Applies after 6 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      Residential: "-",
      note: ""
    },
    {
      "Placard Removal Sweep Out": "$120/$80",
      note: "The consignee is responsible for this process."
    },
    {
      "Truck Order Not Used": "-",
      note:
        "This charge includes linehaul cost + FSC + two (2) days of chassis."
    },
    {
      "Reefer Storage": "$125 to $180",
      note: "This charge is per day."
    },
    {
      "Empty Storage": "$90",
      note: ""
    }
  ],
  footer_upper_text: "",
  footer_note: ""
};

const SAVANNAH_TEMP_CONTROL = {
  rate_table: [
    { "Linehaul Rate + FSC (%)": "$" },
    { Chassis: "$45 per day (2 days minimum)" },
    { Reefer: "$200" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    },
    { "Ocean terminal fee": "$160 may apply" },
    { Prepull: "$160" }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$45",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      Reefer: "$200",
      note: ""
    },
    {
      "Chassis Split": "$120",
      note:
        "Applies if the chassis pick-up/delivery location is different to the container pick-up/delivery."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed. Over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note: "Fee depends on the state the cargo is being hauled at."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: (1.1) (1.2) (1.3) (1.5) (2.3) (3.1) (4.1) (4.2) (4.3) (5.1) (6.1) (6.2) (7) (9.1)"
    },
    {
      "Congestion Fee": "-",
      note: "Charges apply depending on the carrier or ports facility."
    },
    {
      "Toll Charge": "$60",
      note: "If it applies."
    },
    {
      "Terminal/Pier Pass": "",
      note: "Depends on port's fee + administrative fee."
    },
    {
      "Pre-pull": "$160",
      note: "Recommended for early appointments and/or emergencies."
    },
    {
      "Scale Tickets": "$100",
      note:
        "The cost of $100 to scale light (empty) and $100 to scale heavy (loaded)."
    },
    {
      "Stop-off": "$200",
      note: "Extra stop on loading /unloading process."
    },
    {
      "Driver Detention": "$100",
      note: "1 Hour is free for loading/unloading."
    },
    {
      Layover: "$400",
      note:
        "Applies after 6 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      Residential: "-",
      note: ""
    },
    {
      "Placard Removal Sweep Out": "$120/$80",
      note: "The consignee is responsible for this process."
    },
    {
      "Truck Order Not Used": "-",
      note:
        "This charge includes linehaul cost + FSC + two (2) days of chassis."
    },
    {
      "Reefer Storage": "$125 to $180",
      note: "This charge is per day."
    },
    {
      "Empty Storage": "$90",
      note: ""
    }
  ],
  footer_upper_text: "",
  footer_note: ""
};

const OAKLAND_TEMP_CONTROL = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$55 per day (2 days minimum)" },
    { Reefer: "$200" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$55",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      "Reefer Fee": "$200",
      note: ""
    },
    {
      "Chassis Split": "$120",
      note:
        "Applies if the chassis pick-up/delivery location is different to the container pick-up/delivery."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed ($170). Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note: "Fee depends on the state the cargo is being hauled at."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1)(1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$160",
      note: "Recommended for early appointments and/or emergencies."
    },
    {
      "Scale Tickets": "$100",
      note:
        "The cost of $100 to scale light (empty) and $100 to scale heavy (loaded)."
    },
    {
      "Stop-off": "$200",
      note: "Extra stop on loading /unloading process."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      Residential: "-",
      note: ""
    },
    {
      "Placard Removal Sweep Out": "$120/$80",
      note: "The consignee is responsible for this process."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip"
    },
    {
      "Reefer Storage": "$125 to $180",
      note: "This charge is per day."
    },
    {
      "Empty Storage": "$90",
      note: "This charge is per day."
    }
  ],
  footer_upper_text: "",
  footer_note: "Nota: Gate fee may apply"
};

const KANSAS_CITY_TEMP_CONTROL = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$40 per day (2 days minimum)" },
    { Reefer: "$200" },
    { "Chassis Split": "$90-$130" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$40",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      "Reefer Fee": "$200",
      note: ""
    },
    {
      "Chassis Split": "$90 - $130",
      note:
        "Applies if the chassis pick-up/delivery location is different to the container pick-up/delivery."
    },
    {
      "Chassis Flip": "$130 each",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed ($170). Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note: "Fee depends on the state the cargo is being hauled at."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1)(1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$160",
      note: "Recommended for early appointments and/or emergencies."
    },
    {
      "Scale Tickets": "$100",
      note:
        "The cost of $100 to scale light (empty) and $100 to scale heavy (loaded)."
    },
    {
      "Stop-off": "$200",
      note: "Extra stop on loading /unloading process."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      Residential: "-",
      note: ""
    },
    {
      "Placard Removal Sweep Out": "$120/$80",
      note: "The consignee is responsible for this process."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip"
    },
    {
      "Reefer Storage": "$125 to $180",
      note: "This charge is per day."
    },
    {
      "Empty Storage": "$90",
      note: ""
    }
  ],
  footer_upper_text: "",
  footer_note:
    "Nota: There will be a $180 surcharge added to the base rate for all loads/chassis originating or terminating back to Edgerton, KS or LPKC BNSF."
};

const MINNEAPOLIS_TEMP_CONTROL = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$45 per day (2 days minimum)" },
    { Reefer: "$200" },
    {
      "Chassis Split": "$100 each (two charges may apply: pick up and return)"
    },
    { "CP Surcharge (If used as origin or termination)": "$120" },
    { "Chassis flip": "$120" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$45",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      "Reefer Fee": "$200",
      note: ""
    },
    {
      "Chassis Split": "$100",
      note:
        "Applies if the chassis pick-up/delivery location is different to the container pick-up/delivery."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$95",
      note:
        "Charges are per day and two (2) days minimum will be billed ($170). Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note: "Fee depends on the state the cargo is being hauled at."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1) (1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$160",
      note: "Recommended for early appointments and/or emergencies."
    },
    {
      "Scale Tickets": "$100",
      note:
        "The cost of $100 to scale light (empty) and $100 to scale heavy (loaded)."
    },
    {
      "Stop-off": "$200",
      note: "Extra stop on loading /unloading process."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      "Placard Removal Sweep Out": "$120/$80",
      note: "The consignee is responsible for this process."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip"
    },
    {
      "Reefer Storage": "$125 - $180",
      note: "This charge is per day."
    },
    {
      "Empty Storage": "$90",
      note: "This charge is per day."
    }
  ],
  footer_upper_text: "",
  footer_note: "Rate not applicable in New Richmond Terminal in MN"
};

const BALTIMORE_TEMP_CONTROL = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$45 per day (2 days minimum)" },
    { Reefer: "$200" },
    { "Chassis Split": "$90 out of Seagirt Terminal)" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    },
    { Prepull: "$160" },
    { Tolls: "$160 May Apply" }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$45",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      Reefer: "$200",
      note: ""
    },
    {
      "Chassis Split": "$90",
      note:
        "Applies if the chassis pick-up/delivery location is different to the container pick-up/delivery."
    },
    {
      "Pre pull": "$160",
      note: ""
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed ($170). Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note: "Fee depends on the state the cargo is being hauled at."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1) (1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$160",
      note: "Recommended for early appointments and/or emergencies."
    },
    {
      "Scale Tickets": "$100",
      note:
        "The cost of $100 to scale light (empty) and $100 to scale heavy (loaded)."
    },
    {
      "Stop-off": "$200",
      note: "Extra stop on loading /unloading process."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      "Placard Removal Sweep Out": "$120/$80",
      note: "The consignee is responsible for this process."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip"
    },
    {
      "Reefer Storage": "$125 - $180",
      note: "This charge is per day."
    },
    {
      "Empty Storage": "$90",
      note: "This charge is per day."
    }
  ],
  footer_upper_text: "",
  footer_note: ""
};

const PORT_EVERGLADES_TEMP_CONTROL = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$40 per day (2 days minimum)" },
    { Reefer: "$200" },
    { Storage: "$65 per day (if applies)" },
    { Prepull: "$230 (if applies)" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$40",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      Reefer: "$200",
      note: ""
    },
    {
      "Chassis Split": "$120",
      note:
        "Applies if the chassis pick-up/delivery location is different to the container pick-up/delivery."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$130",
      note:
        "Charges are per day and two (2) days minimum will be billed . Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note: "Fee depends on the state the cargo is being hauled at."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1)(1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$230",
      note: "Recommended for early appointments and/or emergencies."
    },
    {
      "Scale Tickets": "$100",
      note:
        "The cost of $100 to scale light (empty) and $100 to scale heavy (loaded)."
    },
    {
      "Stop-off": "$200",
      note: "Extra stop on loading /unloading process."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      Residential: "-",
      note: ""
    },
    {
      "Placard Removal Sweep Out": "$120/$80",
      note: "The consignee is responsible for this process."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip"
    },
    {
      "Reefer Storage": "$125 to $180",
      note: "This charge is per day."
    },
    {
      "Empty Storage": "$90",
      note: "This charge is per day."
    }
  ],
  footer_upper_text:
    "Due to terminal congestion NO FREE TIME in/out of Miami/Port Everglades terminals.",
  footer_note:
    "Note: Export containers returning to Port Everglades might have an extra charge of $28.50 for a scale fee."
};

const MEMPHIS_TEMP_CONTROL = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$40 per day (2 days minimum)" },
    { Reefer: "$200" },
    { "Chassis split": "$160 - $170" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$40",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping paperwork for the carrier to review."
    },
    {
      Reefer: "$200",
      note: ""
    },
    {
      "Chassis Split": "$160 - $170",
      note:
        "Applies if the chassis pick-up/delivery location is different to the container pick-up/delivery."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container needs to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others"
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed ($170). Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note: "Fee depends on the state the cargo is being hauled at."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1) (1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$160",
      note: "Recommended for early appointments and/or emergencies."
    },
    {
      "Scale Tickets": "$160",
      note:
        "The cost of $160 to scale light (empty) and $100 to scale heavy (loaded)."
    },
    {
      "Stop-off": "$200",
      note: "Extra stop on loading /unloading process."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      "Placard Removal Sweep Out": "$120/$80",
      note: "The consignee is responsible for this process."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip"
    },
    {
      "Reefer Storage": "$125 to $180",
      note: "This charge is per day."
    },
    {
      "Empty Storage": "$90",
      note: "This charge is per day."
    }
  ],
  footer_upper_text: "",
  footer_note: "Note: If comming/going to UP/CP add $120 or NS add $170"
};

const CHICAGO_TEMP_CONTROL = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$40 per day (2 days minimum)" },
    { Reefer: "$200" },
    { "Chassis split": "$180" },
    { Prepull: "$210" },
    { Congestion: "$230" },
    { Storage: "$60 per day (If applicable)" },
    { Tolls: "$100 (If applicable)" },
    { "If out of Elwood/Joliet please add:": "$100 - $180" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        ""
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$40",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      Reefer: "$200",
      note: ""
    },
    {
      "Chassis Split": "180",
      note:
        "Applies if the chassis pick-up/delivery location is different to the container pick-up/delivery."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed ($170). Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note: "Fee depends on the state the cargo is being hauled at."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1)(1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$210",
      note: "Recommended for early appointments and/or emergencies."
    },
    {
      "Scale Tickets": "$100",
      note:
        "The cost of $100 to scale light (empty) and $100 to scale heavy (loaded)."
    },
    {
      "Stop-off": "$200",
      note: "Extra stop on loading /unloading process."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      Residential: "-",
      note: "-"
    },
    {
      "Placard Removal Sweep Out": "$120/$80",
      note: "The consignee is responsible for this process."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip"
    },
    {
      "Reefer Storage": "$125 to $180",
      note: "This charge is per day."
    },
    {
      "Empty Storage": "$90",
      note: ""
    }
  ],
  footer_upper_text: "",
  footer_note:
    "Note: there is a chassis shortage and we will not be responsible for Demurrage/Rail Storage."
};

const ATLANTA_TEMP_CONTROL = {
  rate_table: [
    { "Linehaul Rate + FSC (included)": "$" },
    { Chassis: "$45 per day (2 days minimum)" },
    { Reefer: "$200" },
    { "Chassis split": "$120" },
    { "Intermodal fee": "$130" },
    {
      "Redelivery may apply if the container is not able to be returned same day once it is loaded/unloaded":
        "180"
    }
  ],
  accessorials_table: [
    {
      "Chassis Fee": "$45",
      note:
        "Charges are per day and two (2) days minimum will be billed. Customers that are exempt from chassis fees must have their contract number on their shipping’s paperwork for the carrier to review."
    },
    {
      Reefer: "$200",
      note: ""
    },
    {
      "Chassis Split": "$120",
      note:
        "Applies if the chassis pick-up/delivery location is different to the container pick-up/delivery."
    },
    {
      "Chassis Flip": "$120",
      note:
        "This charge applies when a container is needed to be moved from the original chassis to a different one. It generally applies for special equipment (tri-axle chassis) or at wheeled facility used temporarily and owned by others."
    },
    {
      "Triaxle Charge": "$85",
      note:
        "Charges are per day and two (2) days minimum will be billed ($170). Apply when weight is over 38000 lbs. in a 20' / Over 44000 lbs. in a 40'."
    },
    {
      "Overweight Fee": "-",
      note: "Fee depends on the state the cargo is being hauled at."
    },
    {
      Hazmat: "-",
      note:
        "We cannot haul: Class (1.1) (1.2)(1.3)(1.4)(1.5)(1.6)(2.3)(6.1)(6.2)(7)"
    },
    {
      "Pre-pull": "$160",
      note: "Recommended for early appointments and/or emergencies."
    },
    {
      "Scale Tickets": "$100",
      note:
        "The cost of $100 to scale light (empty) and $100 to scale heavy (loaded)."
    },
    {
      "Stop-off": "$200",
      note: "Extra stop on loading /unloading process."
    },
    {
      Layover: "$400",
      note:
        "Applies after 3 hours. Detention charges also apply if the lane exceeds 250 miles."
    },
    {
      "Placard Removal Sweep Out": "$120/$80",
      note: "The consignee is responsible for this process."
    },
    {
      "Truck Order Not Used": "-",
      note: "Cost of Linehaul - Round Trip"
    },
    {
      "Reefer Storage": "$125 to $180",
      note: "This charge is per day."
    },
    {
      "Empty Storage": "$90",
      note: ""
    }
  ],
  footer_upper_text: "",
  footer_note: ""
};

module.exports = {
  GENERAL_TABLE,
  NY_NJ_DRAYAGE_TABLE,
  CALIFORNIA_DRAYAGE_TABLE,
  BALTIMORE_DRAYAGE_TABLE,
  BOSTON_DRAYAGE_TABLE,
  OAKLAND_DRAYAGE_TABLE,
  CHICAGO_DRAYAGE_TABLE,
  KANSAS_DRAYAGE_TABLE,
  CINCINNATI_COLUMBUS_DRAYAGE_TABLE,
  MIAMI_DRAYAGE_TABLE,
  PORT_EVERGLADES_DRAYAGE_TABLE,
  MEMPHIS_DRAYAGE_TABLE,
  MINNEAPOLIS_DRAYAGE_TABLE,
  ATLANTA_DRAYAGE_TABLE,
  HOUSTON,
  NEW_ORLEANS,
  NORFOLK,
  DETROIT_DRAYAGE_TABLE,
  CHARLESTON_DRAYAGE_TABLE,
  /* TEMP CONTROL CANNED */
  DRAYAGE_QUOTE_GENERAL,
  DRAYAGE_CALIFORNIA_LA_LB,
  DRAYAGE_QUOTE_NY_NJ,
  DRAYAGE_QUOTE_MIAMI,
  DRAYAGE_QUOTE_CHICAGO,
  HOUSTON_TEMP_CONTROL,
  NEW_ORLEANS_TEMP_CONTROL,
  NORFOLK_TEMP_CONTROL,
  BOSTON_TEMP_CONTROL,
  CINCINNATI_COLOMBUS_TEMP_CONTROL,
  SAVANNAH_TEMP_CONTROL,
  OAKLAND_TEMP_CONTROL,
  KANSAS_CITY_TEMP_CONTROL,
  MINNEAPOLIS_TEMP_CONTROL,
  BALTIMORE_TEMP_CONTROL,
  PORT_EVERGLADES_TEMP_CONTROL,
  MEMPHIS_TEMP_CONTROL,
  CHICAGO_TEMP_CONTROL,
  ATLANTA_TEMP_CONTROL
};
